module.exports = __webpack_public_path__ + "static/media/MyriadPro-Regular.a89cf050.otf";